<template>
  <div>
    <main class="main product-details-main">
      <PagesPath
        :pathTitle1="'پست ها'"
        :pathTo1="'/weblog-list'"
        class="mt-3"
      />

      <div class="weblog-list-grid container text-right mt-md-5 mt-3">
        <div class="weblog-list-main">
          <b-skeleton class="skeleton-search" v-if="status"></b-skeleton>
          <div v-else>
            <!-- باکس جستوجو پست -->
            <form @submit.prevent="blogSearch" id="seatchBlogSection" class="">
              <input
                type="text"
                id="seacrchInBlogs"
                v-model="search"
                placeholder="جستوجوی مقاله ..."
              />
              <button type="button" class="d-inline-block  bg-none ">
                <svg
                  class="search-icon"
                  width="27"
                  height="27"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="11.7666"
                    cy="11.7666"
                    r="8.98856"
                    stroke="#444"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.0183 18.4851L21.5423 22"
                    stroke="#444"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <b-spinner
                v-if="spinnerSearch"
                type="grow"
                label="Spinning"
              ></b-spinner>
            </form>
            <!-- <hr id="hrSearch" /> -->
          </div>
          <!-- <h4 class="mb-4">لیست مطالب</h4> -->

          <div v-if="status" class="content-list-skeleton-filter">
            <ul class="list-skeleton-filter">
              <li v-for="item in 4" :key="item">
                <b-skeleton class="skeleton-filter"></b-skeleton>
              </li>
            </ul>
          </div>
          <section
            v-else-if="blogs && blogs.category && blogs.category.length"
            class="
              weblog-filter

              
            
             
            "
          >
            <ul class=" ">
              <li>
                <router-link
                  class="fontsize-medium"
                  :to="`/weblog-list`"
                  :class="{ 'active-link': !$route.params.id }"
                >
                  همه مقالات
                </router-link>
              </li>
              <li
                v-for="(category, index) in blogs.category"
                :key="'category' + index"
              >
                <router-link
                  class="fontsize-medium"
                  :to="`/weblog-list/${category.id}/${category.slug}`"
                  :class="{ 'active-link': $route.params.id == category.id }"
                >
                  {{ category.name }}
                </router-link>
              </li>
            </ul>
          </section>
          <div v-if="status">
            <b-row>
              <b-col>
                <b-skeleton class=""></b-skeleton>
                <br />
                <b-skeleton-img></b-skeleton-img>
                <br />
                <b-skeleton></b-skeleton>
                <br />
                <b-skeleton></b-skeleton>
              </b-col>
              <b-col>
                <b-skeleton></b-skeleton>
                <br />
                <b-skeleton-img></b-skeleton-img>
                <br />
                <b-skeleton></b-skeleton>
                <br />
                <b-skeleton></b-skeleton>
              </b-col>
              <b-col>
                <b-skeleton></b-skeleton>
                <br />
                <b-skeleton-img></b-skeleton-img>
                <br />
                <b-skeleton></b-skeleton>
                <br />
                <b-skeleton></b-skeleton>
              </b-col>
            </b-row>
          </div>
          <section v-else class="weblog-list-main-grid">
            <template v-if="blogs.length != 0">
              <!-- <Weblog
                v-for="(weblog, index) in blogs.posts.data"
                :key="index"
                :weblog="weblog"
              ></Weblog> -->
              <postCard
                class="w-100"
                v-for="(blog, index) in blogs.posts.data"
                :key="index"
                :blog="blog"
              />
            </template>
            <div v-else>
              <span>پستی برای نمایش وجود ندارد</span>
            </div>
          </section>
          <b-skeleton v-if="status"></b-skeleton>
          <section
            id="mainPaginationBlog"
            v-else
            class="weblog-list-pagination text-center my-4 p-2 bg-color-fa"
          >
            <section
              v-if="blogs && blogs.posts != ''"
              id="listPagination"
              class="
                list-pagination
                weblog-list-pagination
                text-center
                my-4
                py-2
              "
            >
              <pagination
                :limit="1"
                :data="blogs.posts"
                @pagination-change-page="changePage"
                :disabled="disabled"
                class="justify-content-center"
              >
                <span slot="prev-nav">
                  <ZPrevSvg />
                </span>
                <span slot="next-nav">
                  <ZNextSvg />
                </span>
              </pagination>
            </section>
            <!-- <pagination :data="blogs.posts.links" :router="true" @pagination-change-page="changePage"></pagination> -->
          </section>
          <!-- <section
            class="
              list-next-prev-btn
              d-flex
              flex-wrap
              justify-content-between
              mb-3
              d-lg-none
            "
          >
          <b-skeleton v-if="status" type="button"></b-skeleton>
            <button
            v-else
              class="
                d-flex
                justify-content-center
                bg-color-ea
                p-2

                mb-2
                w-49
              "

              :class="{'disableLink':blogs.posts.prev_page_url==null}"
              @click.prevent="showBlogs(blogs.posts.prev_page_url)"
            >
              <span class="mr-2 fontsize14 weight-bold text-color-444 py-2"
                >صفحه قبلی</span
              >
            </button>
          <b-skeleton v-if="status" type="button"></b-skeleton>

            <button
            v-else
              :class="{'disableLink':blogs.posts.next_page_url==null}"
              @click.prevent="showBlogs(blogs.posts.next_page_url)"
              class="
                d-flex
                justify-content-center
                bg-color-ea
                p-2

                mb-2
                w-49
              "
            >
              <span class="mr-2 fontsize14 weight-bold text-color-444 py-2">
                صفحه بعدی</span
              >
            </button>
          </section> -->
        </div>
        <!-- <div class="welog-list-side">
          <b-skeleton-img v-if="status"></b-skeleton-img>
          <br v-if="status" />

          <section
            v-else
            class="
              weblog-categories

              box-shaddow20
              p-3
              bg-white
              mb-3
            "
          >
            <div class="d-flex border-bottom-dashed pb-2">
              <h6 class="mr-2 weight-bold text-color-444 fontsize-medium ">
                دسته بندی ها
              </h6>
            </div>
            <ul class="py-3">
              <li
                v-for="(category, index) in blogs.category"
                :key="'category' + index"
              >
                <router-link
                  class="fontsize-small"
                  :to="`/weblog-list/${category.id}/${category.slug}`"
                  :class="{ 'text-black': $route.params.id == category.id }"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="11"
                    fill="currentColor"
                    class="bi bi-chevron-left"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                  {{ category.name }}
                </router-link>
              </li>
            </ul>
          </section>
          <section
            class="
              advertisting1
              bg-color-ea

              overflow-hidden
              box-shaddow20
              text-center
              mb-3
            "
          >
            <a href=""><img src="@/assets/images/banner1.png" alt=""/></a>
          </section>

          <section
            class="
              weblog-last-articles

              box-shaddow20
              p-3
              bg-white
              mb-3
            "
          >
            <div class="d-flex border-bottom-dashed pb-2 mb-3">
              <h5 class="mr-2 fontsize18 weight-bold text-color-444">
                آخرین مطالب
              </h5>
            </div>
            <article>
              <a class="d-flex mb-3" href="">
                <div class="weblog-last-articles-img ml-1">
                  <img src="@/assets/images/art3.jpg" alt="" />
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="fontsize15 text-color-666">
                    انتخاب لباس های مناسب مسافرت خارجی
                  </h6>
                  <div
                    class="d-flex justify-content-between align-items-baseline"
                  >
                    <span class="fontsize12 text-color-999">شنبه 12 مرداد</span>
                    <span class="text-color-999">/</span>
                    <button class="fontsize13 text-color-theme bg-none">
                      اطلاعات بیشتر...
                    </button>
                  </div>
                </div>
              </a>
            </article>
            <article>
              <a class="d-flex mb-3" href="">
                <div class="weblog-last-articles-img ml-1">
                  <img src="@/assets/images/art2.jpg" alt="" />
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="fontsize15 text-color-666">
                    انتخاب لباس های مناسب مسافرت خارجی
                  </h6>
                  <div
                    class="d-flex justify-content-between align-items-baseline"
                  >
                    <span class="fontsize12 text-color-999">شنبه 12 مرداد</span>
                    <span class="text-color-999">/</span>
                    <button class="fontsize13 text-color-theme bg-none">
                      اطلاعات بیشتر...
                    </button>
                  </div>
                </div>
              </a>
            </article>
            <article>
              <a class="d-flex mb-3" href="">
                <div class="weblog-last-articles-img ml-1">
                  <img src="@/assets/images/art3.jpg" alt="" />
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="fontsize15 text-color-666">
                    انتخاب لباس های مناسب مسافرت خارجی
                  </h6>
                  <div
                    class="d-flex justify-content-between align-items-baseline"
                  >
                    <span class="fontsize12 text-color-999">شنبه 12 مرداد</span>
                    <span class="text-color-999">/</span>
                    <button class="fontsize13 text-color-theme bg-none">
                      اطلاعات بیشتر...
                    </button>
                  </div>
                </div>
              </a>
            </article>
            <article>
              <a class="d-flex mb-3" href="">
                <div class="weblog-last-articles-img ml-1">
                  <img src="@/assets/images/art2.jpg" alt="" />
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="fontsize15 text-color-666">
                    انتخاب لباس های مناسب مسافرت خارجی
                  </h6>
                  <div
                    class="d-flex justify-content-between align-items-baseline"
                  >
                    <span class="fontsize12 text-color-999">شنبه 12 مرداد</span>
                    <span class="text-color-999">/</span>
                    <button class="fontsize13 text-color-theme bg-none">
                      اطلاعات بیشتر...
                    </button>
                  </div>
                </div>
              </a>
            </article>
            <article>
              <a class="d-flex mb-3" href="">
                <div class="weblog-last-articles-img ml-1">
                  <img src="@/assets/images/art3.jpg" alt="" />
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="fontsize15 text-color-666">
                    انتخاب لباس های مناسب مسافرت خارجی
                  </h6>
                  <div
                    class="d-flex justify-content-between align-items-baseline"
                  >
                    <span class="fontsize12 text-color-999">شنبه 12 مرداد</span>
                    <span class="text-color-999">/</span>
                    <button class="fontsize13 text-color-theme bg-none">
                      اطلاعات بیشتر...
                    </button>
                  </div>
                </div>
              </a>
            </article>
            <article>
              <a class="d-flex mb-3" href="">
                <div class="weblog-last-articles-img ml-1">
                  <img src="@/assets/images/art2.jpg" alt="" />
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="fontsize15 text-color-666">
                    انتخاب لباس های مناسب مسافرت خارجی
                  </h6>
                  <div
                    class="d-flex justify-content-between align-items-baseline"
                  >
                    <span class="fontsize12 text-color-999">شنبه 12 مرداد</span>
                    <span class="text-color-999">/</span>
                    <button class="fontsize13 text-color-theme bg-none">
                      اطلاعات بیشتر...
                    </button>
                  </div>
                </div>
              </a>
            </article>
          </section>
        </div> -->
      </div>
    </main>

    <Footer></Footer>
  </div>
</template>

<script>
import PagesPath from "@/parts/Front/components/PagesPath";
import pagination from "shetabit-laravel-vue-pagination";
import { BSkeleton, BSkeletonImg, BRow, BCol } from "bootstrap-vue";

// import Weblog from "@/parts/Front/components/Weblog";
import mixin from "@@/core/mixins/mixins.js";
import ZPrevSvg from "@/parts/Front/components/shared/ZPrevSvg";
import ZNextSvg from "@/parts/Front/components/shared/ZNextSvg";
import config from "../../../config";
import postCard from "../components/postCard.vue";
export default {
  name: "WeblogList",
  mixins: [mixin],
  components: {
    ZNextSvg,
    ZPrevSvg,
    // Weblog,
    PagesPath,
    pagination,
    postCard,
    BSkeleton,
    BSkeletonImg,
    BRow,
    BCol,
  },
  data() {
    return { search: null, spinnerSearch: false, selectedCategoryId: null };
  },
  mounted() {
    //get height of advertisting1
    const advertisting1 = document.querySelectorAll(".advertisting1")[0];
    if (advertisting1) {
      advertisting1.style.height = advertisting1.offsetWidth / 1.5 + "px";
    }

    window.addEventListener("resize", function() {
      const advertisting1 = document.querySelectorAll(".advertisting1")[0];
      if (advertisting1) {
        advertisting1.style.height = advertisting1.offsetWidth / 1.5 + "px";
      }

      // get height of articles/
      const articleImg = document.querySelectorAll(".article-img");
      for (let iImg of articleImg) {
        let imgH = iImg.offsetWidth / 1.45;
        iImg.style.height = imgH + "px";
      }
    });

    // get height of articles/
    let bodyWidth = document.body.offsetWidth;
    const articleImg = document.querySelectorAll(".article-img");
    if (bodyWidth < 767) {
      for (let iImg of articleImg) {
        let imgH = iImg.offsetWidth / 1.45;
        iImg.style.height = imgH + "px";
      }
    }
  },
  created() {
    // در صورت خالی بودن لیست پست ها اطلاعات از سمت سرور فتچ شود
    if (this.blogs == null) {
      // اگر دسته بندی انتخاب شده باشد
      if (this.$route.params.id) {
        const data = {
          category: this.$route.params.id,
        };
        // و اگر صفحه بندی نیز انتخاب شده باشد
        if (this.$route.query.page) {
          data.page = this.$route.query.page;
        }
        // ارسال درخواست
        this.$store.dispatch("front/getAllBlogFromServer", data);
      } else {
        // اگر دسته بندی انتخاب نشده باشد
        const data = {};
        // ولی اگر صفحه بندی داشت
        if (this.$route.query.page) {
          data.page = this.$route.query.page;
        }
        this.$store.dispatch("front/getAllBlogFromServer", data);
      }
    }
  },
  computed: {
    // دریافت اطلاعات از ویو ایکس برای لیست پست ها
    blogs() {
      return this.$store.getters["front/getAllBlog"];
    },
    status() {
      // برای نمایش لودر ها
      return this.$store.getters["front/getStatusAllBlog"];
    },
    homeData() {
      if (this.$store.getters["front/getHomeData"] != null) {
        return this.$store.getters["front/getHomeData"];
      } else {
        return null;
      }
    },
  },
  methods: {
    showBlogs(link) {
      if (link == null) return;
      // page=             پیدا کردن عدد مقابل کوئری
      // نمایش در یو آر ال و صدا زدن تابع فتچ
      let pageIndex = link.search("page=");
      let page = link.slice(pageIndex + 5);
      this.$router.replace({ name: "weblogList", query: { page: page } });
      // this.$route.query.page=page;
      // let data={
      //   page:page
      // };
      // if(this.$route.params.id){
      //   data.category=this.$route.params.id
      // }
      //  this.$store.dispatch("front/getAllBlogFromServer",data);
    },
    blogSearch() {
      this.spinnerSearch = true;

      if (this.search != null) {
        //با کلیک روی دکمه سرچ جستوجو در بلاگ ها صورت میگیرد
        this.$store.dispatch("front/searchInBlog", this.search);
      } else {
        // در صورت خالی بودن فوکز شود روی اینپوت
        document.getElementById("seacrchInBlogs").focus();
        this.spinnerSearch = false;
      }
    },
    // تابع زیر برای اضافه کردن متا تگ و بالا بردن سئو است
  },
  watch: {
    blogs(newVal, oldVal) {
      if (newVal != oldVal) {
        //برای غیر فعالسازی اسپینر هنگام سرچ
        this.spinnerSearch = false;
      }
    },
    "$route.params.id": {
      handler: function(val) {
        const data = {
          category: val,
        };
        if (this.$route.query.page) {
          data.page = this.$route.query.page;
        }
        this.$store.dispatch("front/getAllBlogFromServer", data);
      },
      immediate: true,
    },
    "$route.query.page": {
      handler: function(val) {
        const data = {
          page: val,
        };
        if (this.$route.params.id) {
          data.category = this.$route.params.id;
        }
        this.$store.dispatch("front/getAllBlogFromServer", data);
      },
      immediate: true,
    },
  },
  metaInfo() {
    return {
      title: this.homeData
        ? config.title +
          ` - ${this.homeData.settings.general.meta_title_weblog_list}`
        : config.title,
      meta: [
        {
          name: "title",
          content: this.homeData
            ? this.homeData.settings.general.meta_title_weblog_list
            : false,
        },
        {
          name: "description",
          content: this.homeData
            ? this.homeData.settings.general.meta_description_weblog_list
            : false,
        },
        {
          property: "og:title",
          content: this.homeData
            ? this.homeData.settings.general.meta_title_weblog_list
            : false,
        },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
</script>

<style scoped>
li {
  list-style-type: none;
}
.weblog-list-grid {
  grid-template-columns: 1fr;
}
.weblog-list-main {
  min-width: 100%;
}
.weblog-list-main-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}
.weblog-filter {
  min-width: 100%;
  overflow: auto;
  margin-bottom: 1rem;
}
.weblog-filter ul {
  display: flex;
  justify-content: center;
}
.weblog-filter ul li a {
  color: rgb(148, 148, 148);
  padding: 0px 1.25rem 0.625rem;
  display: inline-block;
  border-bottom: 1px solid rgb(148, 148, 148);
  white-space: nowrap;
}
.weblog-filter ul li a.active-link {
  color: #000;
  border-bottom: 2px solid black;
}
.weblog-filter ul li::marker {
  list-style: unset !important;
  display: none;
  content: "";
}
.skeleton-search {
  max-width: 600px;
  height: 30px;
  margin-bottom: 1rem;
}
.content-list-skeleton-filter {
  width: 100%;
  overflow: auto;
  margin-bottom: 1rem;
}
.list-skeleton-filter {
  width: 100%;
  display: flex;
  gap: 16px;
  justify-content: center;
}
.skeleton-filter {
  width: 150px;
  height: 30px;
}
#seatchBlogSection {
  width: 600px;
  display: flex;
  border: 1px solid rgba(148, 148, 148, 0.466);
  border-radius: 8px;
  padding: 8px 6px;
  margin-inline: auto;
  margin-bottom: 20px;
}
#hrSearch {
  margin-top: 3px;
}
#seacrchInBlogs {
  flex-grow: 10;
  background: transparent;
}
#seacrchInBlogs::placeholder {
  font-size: 14px;
}
/* @media (max-width:991px){
  #mainPaginationBlog{
    display: none!important;
  }
} */
/* افزودن استایل به کامپوننت اضافه شده  */
.pagination {
  justify-content: center;
  flex-direction: row;
}

/*تعمیر قالب   */
#mainPaginationBlog {
  background: none !important;
}
#listPagination {
  background: none !important;
}

/* @media screen and (max-width: 1199px) {
  
} */
@media screen and (max-width: 1380px) {
  .weblog-list-main-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 990px) {
  #seatchBlogSection {
    width: 100%;

    padding: 6px;
  }
  .search-icon {
    width: 20px;
    height: 20px;
  }
  .weblog-list-main-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .skeleton-search {
    max-width: 100%;
    height: 30px;
  }
  .list-skeleton-filter {
    gap: 10px;
  }
  .skeleton-filter {
    width: 60px;
    height: 30px;
  }
}
@media screen and (max-width: 648px) {
  .weblog-list-main-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  .weblog-filter ul li a {
    padding: 0px 0.75rem 0.45rem;
  }
}
@media screen and (max-width: 500px) {
  .weblog-list-main-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
  }
}
</style>
